<template>
  <div>
      <div class="media" v-if="type == 'img'">
        <transition name="fadeIn">
          <img v-show="loaded"
            @load="onLoad"
            :src="image"
            sizes="(max-width: 576px) 100vw, 575px, 800px, (min-width: 800px) 100vw"
            :srcset="
              thumb + ' 320w,'
              + image + ' 575w,'
              + largeImage + ' 800w,'
              + largeImage + ' 1200w'"
            :alt="alt"
          />
        </transition>
      </div>
    <div class="media" v-if="type == 'mp4'">
      <transition name="fadeIn">
        <div v-show="videoLoaded">
          <video width="100%" autoplay loop muted>
            <source :src="thumb" @load="onLoad" type="video/mp4">
            <source :src="thumb" @load="onLoad" type="video/ogg">
            Your browser does not support the video tag.
          </video>
        </div>
      </transition>
    </div>
 </div>
</template>
<script>
export default {
  components: {},
  props: ['url', 'type', 'alt'],
  name: "imageBlur",
  data() {
      return {
          thumb: "",
          image: "",
          largeImage: "",
          loaded: false,
          videoLoaded: false,
          color: 'rgba(0,0,0,1)'
      }
  },
  methods: {
    onLoad() {
      var self = this;
      setTimeout(function(){
        self.loaded = true;
      }, Math.floor(100 * Math.random() * 10) + 1);
    }
  },
  mounted() {
    if(this.url) {
      var str = this.url.split(".");
      if(str[1] === 'mp4' || str[1] === 'ogg') {
        this.thumb = process.env.VUE_APP_PUBLIC.slice(0, -1) + this.url;
        this.videoLoaded = true;
      } else {
        this.image = process.env.VUE_APP_PUBLIC.slice(0, -1) + this.url;
        this.largeImage = process.env.VUE_APP_PUBLIC.slice(0, -1) + str[0] + '@2x.' + str[1];
        this.thumb = process.env.VUE_APP_PUBLIC.slice(0, -1) + str[0] + '_small.' + str[1];
      }
    }
  }
}

</script>

<style lang="scss" scoped>
    video {
        object-fit: fill;
    }

    .media {
      position: relative;
      display: block;
      transform: scale(1);
      min-height: 70px;
      max-height: auto;

      img {
        transform: scale(1.001);
      }
    }

    .type-img, .type-mp4 {
      display: block;
      z-index: 10;
      position: relative;
    }

    .fadeIn-enter-active {
      animation: ease-in-out 3s scaleIn, ease-in-out 2s fadeIn;
    }

    @keyframes scaleIn {
      from {transform: scale(1.03);}
      to {transform: scale(1.001);}
    }

    @keyframes fadeIn {
      0% {opacity: 0;}
      50% {opacity: 0;}
      100% {opacity: 1;}
    }
</style>
